import { royalcaninDogProducts } from '../Assets/Product_Info/royalcaninDogProducts'
import { royalcaninCatProducts } from '../Assets/Product_Info/royalcaninCatProducts'
import { eukanubaProducts } from '../Assets/Product_Info/eukanubaProducts'
import { petFoodProducts } from '../Assets/Product_Info/petFoodProducts'
import { nexgardProducts } from '../Assets/Product_Info/nexgardProducts'
import { simparicaProducts } from '../Assets/Product_Info/simparicaProducts'
// import { beenoProducts } from '../Assets/Product_Info/beenoProducts'
import { bravectoProducts } from '../Assets/Product_Info/bravectoProducts'
import { purinaProducts } from '../Assets/Product_Info/purinaProducts'
import { bobmartinProducts } from '../Assets/Product_Info/bobmartinProducts'

export {
  royalcaninDogProducts,
  royalcaninCatProducts,
  eukanubaProducts,
  petFoodProducts,
  nexgardProducts,
  simparicaProducts,
  // beenoProducts,
  bravectoProducts,
  purinaProducts,
  bobmartinProducts,
}

const allProducts = [
  ...royalcaninDogProducts,
  ...royalcaninCatProducts,
  ...eukanubaProducts,
  ...petFoodProducts,
  ...nexgardProducts,
  ...simparicaProducts,
  // ...beenoProducts,
  ...bravectoProducts,
  ...purinaProducts,
  ...bobmartinProducts,
]

export default allProducts

const _idSet = {}
const _categoryIdMap = {}

const _register = (arr, category) => {
  for (const p of arr) {
    _idSet[p.id] = p
    _categoryIdMap[p.id] = category
  }
}

_register(royalcaninDogProducts, 'dog')
_register(eukanubaProducts, 'dog')
_register(royalcaninCatProducts, 'cat')
_register(petFoodProducts, 'petFood')
// _register(beenoProducts, 'dog')
for (const p of nexgardProducts) {
  const cat = p.additionalInfo?.pet_type === 'Cat' ? 'cat' : 'dog'
  _register([p], cat)
}
for (const p of simparicaProducts) {
  const cat = p.additionalInfo?.pet_type === 'Cat' ? 'cat' : 'dog'
  _register([p], cat)
}
for (const p of bravectoProducts) {
  const cat = p.additionalInfo?.pet_type === 'Cat' ? 'cat' : 'dog'
  _register([p], cat)
}
for (const p of purinaProducts) {
  const cat = p.additionalInfo?.pet_type === 'Cat' ? 'cat' : 'dog'
  _register([p], cat)
}
for (const p of bobmartinProducts) {
  const cat = p.additionalInfo?.pet_type === 'Cat' ? 'cat' : 'dog'
  _register([p], cat)
}

export const findProductById = (id) => _idSet[id] || null

export const getProductCategory = (id) => _categoryIdMap[id] || null

export const isPetProduct = (id) => {
  const cat = _categoryIdMap[id]
  return cat === 'dog' || cat === 'cat' || cat === 'petFood'
}
